import React, { memo } from "react";

const UnderOverCard = ({ onBetting, t, item, isWin, oldResult }) => {
    const isWinner =
        isWin &&
        (
            oldResult?.oddEvenCode === item?.code ||
            oldResult?.underOverCode === item?.code
        );

    const handleClick = () => {
        if (typeof onBetting === "function") {
            onBetting(item);
        }
    };

    return (
        <div
            onClick={handleClick}
            className={`game-card ${item?.code || ""} ${isWinner ? "win-animation" : ""}`}
        >
            <div className="title-roulette">
                {t(`labels:betPrefix.${item?.code}`)}
            </div>

            <div className="content">
                <div className="label font-weight-normal">{item?.rangeNumber}</div>
                <div className={`score ${item?.value ? "" : "py-label"}`}>
                    {item?.value}
                </div>
            </div>
        </div>
    );
};

export default memo(UnderOverCard);